import React from 'react'
import {Router} from '@reach/router'
import {CollaborateOnApiDesign} from './collaborate-on-api-design'
import {ConsumerContractValidation} from './consumer-contract-validation'
import {DecoupleApiConsumersProducers} from './decouple-api-consumers-producers'
import {InspectApiRequests} from './inspect-api-requests'
import {ServiceCatalog} from './service-catalog'
import {StabilizeTestEnvironment} from './stabilize-test-environment'

const UseCasesSection = () => {
  return (
    <Router>
      <CollaborateOnApiDesign path='collaborate-on-api-design'/>
      <ConsumerContractValidation path='consumer-contract-validation'/>
      <DecoupleApiConsumersProducers path='decouple-consumers-and-producers'/>
      <InspectApiRequests path='inspect-api-requests'/>
      <ServiceCatalog path='service-catalog'/>
      <StabilizeTestEnvironment path='stabilize-test-environment'/>
    </Router>
  )
}

export {UseCasesSection}

export default UseCasesSection